import React from 'react'
import PropTypes from 'prop-types'
import { FormInput } from 'shards-react'

const ShowTarget = ({ value }) => {
    return <FormInput className="w-50" value={value} readOnly />
}
ShowTarget.propTypes = {
    value: PropTypes.string,
}

export default ShowTarget
